import { render } from "./TaskMessage.vue?vue&type=template&id=7184130c&scoped=true"
import script from "./TaskMessage.vue?vue&type=script&lang=ts"
export * from "./TaskMessage.vue?vue&type=script&lang=ts"

import "./TaskMessage.vue?vue&type=style&index=0&id=7184130c&lang=less&scoped=true"
import "./TaskMessage.vue?vue&type=style&index=1&id=7184130c&lang=less"
script.render = render
script.__scopeId = "data-v-7184130c"

export default script